import React from "react";

function DashboardStatistics({ schoolsNumber, contactsNumber, studentsNumber }) {
  const stats = [
    {
      title: "Schools Registered",
      value: schoolsNumber?.total_p ?? "...",
      imgSrc: "/assets/img/figure/school.png",
    },
    {
      title: "Students Registered",
      value: studentsNumber?.total_p ?? "...",
      imgSrc: "/assets/img/figure/students.png",
    },
    {
      title: "App Signups",
      value: contactsNumber?.total_p ?? "...",
      imgSrc: "/assets/img/figure/phone-call.png",
    },
  ];

  return (
    <div className="col-12-xxxl col-12">
      <div className="row">
        {stats.map((stat, index) => (
          <div key={index} className="col-lg-4">
            <div className="dashboard-summery-one mg-b-20 gradient-my-blue">
              <div className="row align-items-center">
                <div className="col-3">
                  <div className="item-icon bg-light">
                    <img alt={stat.title} style={{ height: "48px" }} src={process.env.PUBLIC_URL + stat.imgSrc} />
                  </div>
                </div>
                <div className="col-9">
                  <div className="item-content">
                    <div className="item-title text-white">{stat.title}</div>
                    <div className="item-number text-white">
                      <span className="counter">{stat.value}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DashboardStatistics;
